<div tuiNotification [appearance]="appearance" [class]="containerClass" [icon]="icon">
  <div class="flex items-start gap-2">
    <div class="flex flex-col items-start gap-2">
      <p>{{ description }}</p>
      <ng-content />
    </div>

    @if (hint) {
      <tui-icon data-testid="hint-icon" [tuiTooltip]="hint" />
    }
  </div>
</div>
